/**
 * Application Routes Configuration
 *
 * Defines all application routes and their corresponding page components
 */

import React from 'react'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Leadership from '@/pages/Leadership'
import Issues from '@/pages/Issues'
import ChildSupportReform from '@/pages/ChildSupportReform'
import EqualSharedParenting from '@/pages/EqualSharedParenting'
import ResearchHub from '@/pages/ResearchHub'
import ResearchPage from '@/pages/ResearchPage'
import Contact from '@/pages/Contact'
import Events from '@/pages/Events'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import { Donate } from '@/pages/Donate'

/**
 * Route configuration interface
 */
export interface RouteConfig {
  path: string
  component: React.ComponentType
  label: string
  showInNav?: boolean
  subItems?: RouteConfig[]
}

/**
 * Application routes
 */
export const routes: RouteConfig[] = [
  {
    path: '/',
    component: Home,
    label: 'Home',
    showInNav: true,
  },
  {
    path: '/about',
    component: About,
    label: 'About',
    showInNav: true,
  },
  {
    path: '/leadership',
    component: Leadership,
    label: 'Leadership',
    showInNav: true,
  },
  {
    path: '/issues',
    component: Issues,
    label: 'Issues',
    showInNav: true,
    subItems: [
      {
        path: '/issues/child-support-reform',
        component: ChildSupportReform,
        label: 'Child Support Reform',
        showInNav: true,
      },
      {
        path: '/issues/equal-shared-parenting',
        component: EqualSharedParenting,
        label: 'Equal Shared Parenting',
        showInNav: true,
      },
    ],
  },
  {
    path: '/research',
    component: ResearchHub,
    label: 'Research',
    showInNav: true,
    subItems: [
      {
        path: '/research/:slug',
        component: ResearchPage,
        label: 'Overnights & Parenting Plans',
        showInNav: true,
      },
    ],
  },
  {
    path: '/contact',
    component: Contact,
    label: 'Contact',
    showInNav: true,
  },
  {
    path: '/events',
    component: Events,
    label: 'Events',
    showInNav: true,
  },
  {
    path: '/donate',
    component: Donate,
    label: 'Donate',
    showInNav: true,
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy,
    label: 'Privacy Policy',
    showInNav: false,
  },
]

/**
 * Helper function to get route by path
 */
export const getRouteByPath = (path: string): RouteConfig | undefined => {
  return routes.find(route => route.path === path)
}

/**
 * Helper function to get all navigation routes
 */
export const getNavigationRoutes = (): RouteConfig[] => {
  return routes.filter(route => route.showInNav)
}
